import type { IssuedApiKey } from "../context/apiKeyContext";

/**
 * 発行した APIキー (平文 full_key 入り) のエクスポート (#468 Phase B)。
 * AWS IAM のアクセスキー発行と同様、平文キーを **その場で .csv ダウンロード** できるようにする。
 * 平文キーは再表示不可のため、コピーに加えてダウンロードでの保存手段を提供する。
 */

/** RFC4180 の最小 CSV セル化 (カンマ/改行/ダブルクオートを含む値はクオート + " を二重化)。 */
function csvCell(value: string): string {
  const s = value ?? "";
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export const API_KEY_CSV_HEADERS = ["name", "key_prefix", "api_key", "created_at", "expires_at"] as const;

/** 発行キー 1 件を CSV 文字列にする (Excel 互換 BOM + CRLF、ヘッダ + 1 行)。純関数 (テスト用)。 */
export function buildApiKeyCsv(key: IssuedApiKey): string {
  const header = API_KEY_CSV_HEADERS.join(",");
  const row = [key.name, key.key_prefix, key.full_key, key.created_at, key.expires_at ?? ""]
    .map((v) => csvCell(String(v)))
    .join(",");
  return "﻿" + header + "\r\n" + row + "\r\n";
}

/** ダウンロード用ファイル名 (key_prefix は ASCII 安全)。 */
export function apiKeyCsvFilename(key: IssuedApiKey): string {
  return `aim-api-key-${key.key_prefix}.csv`;
}

/** ブラウザで発行キーの CSV をダウンロードする (Blob + 一時 <a>)。 */
export function downloadApiKeyCsv(key: IssuedApiKey): void {
  const csv = buildApiKeyCsv(key);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = apiKeyCsvFilename(key);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
